import React from 'react'
import { useIntl } from 'react-intl'
import {
  ousterAuthorDetail,
  wrapper,
  author,
  heroContainer,
  hero,
  leftArrow,
  backLink,
  authorImg,
  authorMeta,
  authorMetaTop,
  authorMetaName,
  authorMetaTitle,
  authorMetaBottom,
  blackCircle,
  previewCardContainer,
  innerAuthor,
  authorBio,
} from './index.module.css'
import MainBlackHeader from '../MainBlackHeader'
import WpBlogPostPreview from '../WpBlogPostPreview'
import SEO from '../SEO'
import Image from '../Image'
import Link from '../Link'
import ArrowRight from '../../../assets/images/ArrowRightNoFill.svg'
import li from '../../../static/li_blog.png'
import tw from '../../../static/tw_blog.png'
import { isSvgOrGif } from '../../utils'

import GbiBridged from '../GbiBridged'

const BackGroundImageWrapper = ({ image, fallback, children, ...rest }) => {
  return (
    <>
      {image && image.localFile.childImageSharp ? (
        <GbiBridged
          height={'100%'}
          width={'100%'}
          {...rest}
          source={image.localFile.childImageSharp.gatsbyImageData}
        >
          {children}
        </GbiBridged>
      ) : isSvgOrGif(image?.localFile?.publicUrl) ? (
        <GbiBridged
          height={'100%'}
          width={'100%'}
          {...rest}
          file={image?.localFile?.publicUrl}
        >
          {children}
        </GbiBridged>
      ) : (
        <GbiBridged
          height={'100%'}
          width={'100%'}
          {...rest}
          source={fallback.localFile.childImageSharp.gatsbyImageData}
        >
          {children}
        </GbiBridged>
      )}
    </>
  )
}

const WpAuthor = ({ data, location, defaultdata, authorPosts }) => {
  const mutatedData = data
  const details = mutatedData ? mutatedData.authorDetails : {}
  const intl = useIntl()
  const blogTitle = intl.formatMessage({ id: 'blog.title' })
  const backToBlog = intl.formatMessage({ id: 'blog.back' })
  const homeUrl = intl.formatMessage({ id: 'blog.homeUrl' })
  const twitterUrl = details ? details?.socialLinks.twitterUrl : null
  const linkedinUrl = details ? details?.socialLinks.linkedinUrl : null
  const checkDetailedBio =
    details &&
    details?.detailedBio !==
      '<div style="display: none;"></div>\n<p>&nbsp;</p>\n' &&
    details?.detailedBio !== null &&
    details?.detailedBio !== undefined

  return (
    <>
      <SEO
        {...data}
        seoTitle={mutatedData.title}
        description={details?.detailedBio}
        slug={`${homeUrl}author/${mutatedData.slug}`}
      />
      <MainBlackHeader
        title={blogTitle}
        ctaUrl={homeUrl}
        secondaryMode
      ></MainBlackHeader>
      <div className={ousterAuthorDetail}>
        <BackGroundImageWrapper
          image={details?.bannerImage}
          fallback={defaultdata.authorBannerDefault}
          className={heroContainer}
        >
          <div className={hero}>
            <div className={author}>
              <div className={innerAuthor}>
                <div className={authorImg}>
                  {details?.profilePicture ? (
                    <Image
                      className={blackCircle}
                      source={details?.profilePicture.localFile.childImageSharp}
                      altText={details?.profilePicture.altText}
                    />
                  ) : isSvgOrGif(
                      details?.profilePicture?.localFile?.publicUrl
                    ) ? (
                    <img
                      src={details?.profilePicture?.localFile?.publicUrl}
                      alt={details?.profilePicture?.altText}
                    />
                  ) : (
                    <Image
                      source={
                        defaultdata.authorProfileDefault.localFile
                          .childImageSharp
                      }
                      alt={defaultdata.authorProfileDefault.altText}
                      className={blackCircle}
                    />
                  )}
                </div>
                <div className={authorMeta}>
                  <div className={authorMetaTop}>
                    <h1 className={authorMetaName}>{mutatedData?.title}</h1>
                    {details?.jobTitle && (
                      <div className={authorMetaTitle}>{details?.jobTitle}</div>
                    )}
                    {(linkedinUrl || twitterUrl) && (
                      <div className={authorMetaBottom}>
                        {linkedinUrl && (
                          <a
                            href={linkedinUrl}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <img src={li} alt="Linkedin Url" />
                          </a>
                        )}
                        {twitterUrl && (
                          <a href={twitterUrl} target="_blank" rel="noreferrer">
                            <img src={tw} alt="Twitter Url" />
                          </a>
                        )}
                      </div>
                    )}
                    {checkDetailedBio && (
                      <div
                        className={authorBio}
                        dangerouslySetInnerHTML={{
                          __html: details?.detailedBio,
                        }}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </BackGroundImageWrapper>

        <div className={wrapper}>
          <div className={backLink}>
            <Link to={homeUrl}>
              <ArrowRight className={leftArrow} />
              {backToBlog}
            </Link>
          </div>
          <div className={previewCardContainer}>
            {authorPosts.map(({ node }, idx) => {
              return (
                <WpBlogPostPreview
                  location={location}
                  defaultdata={defaultdata}
                  data={node}
                  key={idx}
                />
              )
            })}
          </div>
        </div>
      </div>
    </>
  )
}

export default WpAuthor
